import { useNavigate } from 'react-router-dom';
import { useCircleStore } from '../../stores/circle';
import { InviteQR } from '../circle/InviteQR';

export function InvitePartner() {
  const navigate = useNavigate();
  const circle = useCircleStore((s) => s.circle);

  if (!circle) {
    navigate('/onboarding/circle', { replace: true });
    return null;
  }

  const inviteUrl = `${window.location.origin}/join/${circle.invite_code}`;

  return (
    <div className="mx-auto flex min-h-screen max-w-screen-sm flex-col items-center justify-center bg-base px-6 text-text-primary">
      <h1 className="text-2xl font-medium">Invite your partner</h1>
      <p className="mt-2 max-w-sm text-center text-sm text-text-muted">
        Share this link or QR code. They'll set their name and join your circle.
      </p>
      <div className="mt-8 w-full max-w-xs">
        <InviteQR url={inviteUrl} />
      </div>
      <button
        onClick={() => navigate('/app/home', { replace: true })}
        className="mt-6 w-full max-w-xs rounded-xl bg-sage py-3 text-base font-medium text-white"
      >
        I'll do this later
      </button>
    </div>
  );
}
